import { FunctionComponent, memo } from "react";
import { IProps } from "./custom-reports.types";
import PageNames from "constants/page";
import { Page, PageContent, PageHeader } from "@edgetier/client-components";
import useMetabaseDashboards from "hooks-for/custom-reports/use-metabase-dashboards";
import { SpinnerUntil } from "@edgetier/components";
import { Redirect } from "react-router-dom";
import urljoin from "url-join";
import "./custom-reports.scss";

/**
 * A screen to show custom metabase dashboards to users.
 */
const CustomReports: FunctionComponent<IProps> = () => {
    const { data: dashboard } = useMetabaseDashboards(
        {},
        { select: (dashboards) => (Array.isArray(dashboards) && dashboards.length > 0 ? dashboards[0] : null) }
    );

    return (
        <Page>
            <PageHeader title="Custom Reports" />
            <PageContent>
                <div className="custom-reports">
                    <SpinnerUntil<Exclude<typeof dashboard, undefined>>
                        data={dashboard}
                        isReady={typeof dashboard !== "undefined"}
                    >
                        {(dashboard) =>
                            dashboard === null ? (
                                <div className="custom-reports__no-reports">
                                    No custom reports are currently available
                                </div>
                            ) : (
                                <Redirect
                                    to={urljoin(PageNames.CustomReports, dashboard.metabaseDashboardId.toString())}
                                />
                            )
                        }
                    </SpinnerUntil>
                </div>
            </PageContent>
        </Page>
    );
};

export default memo(CustomReports);
